import Marquee from "react-fast-marquee";

const ITEMS = [
  "Garg Stone Company",
  "Since 1988",
  "Rooted in Kota — Built on Trust",
  "Mining & Manufacturing",
  "Kota · Jaisalmer · Basalt",
  "Natural Stone for a Better Tomorrow",
];

const EditorialMarquee = () => (
  <section className="border-y border-bone/10 bg-ink py-7 overflow-hidden" data-testid="marquee-section" aria-hidden="true">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((t, i) => (
        <span key={t} className="flex items-center">
          <span className={`px-10 text-2xl md:text-4xl whitespace-nowrap ${i % 2 ? "font-editorial italic text-bone/50" : "font-heading font-bold uppercase tracking-tight text-bone/30"}`}>
            {t}
          </span>
          <span className="h-2 w-2 rotate-45 bg-copper/80" />
        </span>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
